import { Component, Input } from '@angular/core';
import { environment } from '../../../environments/environment';
import { NgClass, NgOptimizedImage } from '@angular/common';

@Component({
    selector: 'app-page-banner',
    imports: [NgClass, NgOptimizedImage],
    templateUrl: './page-banner.component.html',
    styleUrl: './page-banner.component.scss'
})
export class PageBannerComponent {
    assetsCDNUrl = environment.assetsCDNUrl;
    @Input() bannerContent: any;
}
